module.exports = {
	"payment_methods.title": "Ihre Zahlungsmethode",
	"payment_methods.empty": "Bitte wählen Sie eine Zahlungsmethode",
	"payment_methods.delete": "Entfernen",
	"payment_methods.payment_method": "Zahlungsmethode",
	"login.title": "Einloggen",
	"login.register": "Neu anmelden",
	"login.login": "Einloggen",
	"form.email": "E-Mail-Adresse",
	"form.password": "Passwort festlegen",
	"form.password_confirmation": "Passwort bestätigen",
	"form.remember_me": "Angemeldet bleiben",
	"form.forgot_password": "Passwort vergessen?",
	"subscriptions.title": "Ihre regelmäßigen Spenden",
	"subscriptions.no_donations": "Sie haben keine regelmäßigen Spenden eingerichtet",
	"subscriptions.created": "Eingerichtet",
	"subscriptions.donation_amount": "Spendenbetrag",
	"subscriptions.donation_count": "Anzahl Ihrer Überweisungen",
	"subscriptions.cancel": "Beenden",
	"subscriptions.cancel_confirm": "Möchten Sie Ihre regelmäßige Spende wirklich einstellen?",
	"menu.recurring_donations": "Regelmäßige Spenden",
	"menu.payment_methods": "Zahlungsmethoden",
	"menu.sign_out": "Ausloggen",
	"registration.register": "Neu anmelden",
	"registration.registering": "Sie werden angemeldet...",
	"registration.required": "Notwendiges Feld",
	"registration.invalid_email": "Ungültige E-Mail-Adresse",
	"registration.password_mismatch": "Die Passwörter stimmen nicht überein",
	"registration.password_length": "Das Passwort muss aus mindestens 6 Zeichen bestehen"
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/react-intl/locales/de.json
 ** module id = 946
 ** module chunks = 0
 **/